import { createSlice } from "@reduxjs/toolkit";
import { getDiscussionTopics, getDiscussionTags, getTopicPosts, getPost, getPostDetails, addPost, postLike, postShare, postReply, postBookmark } from './thunk';
export const initialState = {
  topics: [],
  tags: [],
  topicPosts: [],
  suggestedPosts: [],
  posts: [],
  postDetails: {},
  isTopicLoading: false,
  isPostLoading: false,
  isPostDetails: false,
  error: {}
};

const Discussion = createSlice({
  name: 'Discussion',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getDiscussionTopics.fulfilled, (state, action) => {
      state.topics = action.payload;
    });

    builder.addCase(getDiscussionTopics.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getDiscussionTags.fulfilled, (state, action) => {
      state.tags = action.payload;
    });
  
    builder.addCase(getDiscussionTags.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getTopicPosts.pending, (state, action) => {
      state.isTopicLoading = true;
    });

    builder.addCase(getTopicPosts.fulfilled, (state, action) => {
      state.topicPosts = action.payload.TopicPosts;
      state.suggestedPosts = action.payload.Posts;
      state.isTopicLoading = false;
    });
  
    builder.addCase(getTopicPosts.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getPost.pending, (state, action) => {
      state.isPostLoading = true;
    });

    builder.addCase(getPost.fulfilled, (state, action) => {
      state.posts = action.payload;
      state.isPostLoading = false;
    });
  
    builder.addCase(getPost.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(getPostDetails.pending, (state, action) => {
      state.isPostDetails = true;
    });

    builder.addCase(getPostDetails.fulfilled, (state, action) => {
      state.postDetails = action.payload;
      state.isPostDetails = false;
    });
  
    builder.addCase(getPostDetails.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
  
    builder.addCase(addPost.fulfilled, (state, action) => {
      // state.tags = action.payload;
    });
  
    builder.addCase(addPost.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(postLike.fulfilled, (state, action) => {
      state.postDetails = {
        ...state.postDetails,
        PostUser: {
          ...(state.postDetails?.PostUser || {}),
          Interactions: {
            ...(state.postDetails?.PostUser?.Interactions || {}),
            Like: !action.payload[0]?.IsDelete,
            Likes: action.payload[0]?.IsDelete ? state.postDetails?.PostUser?.Interactions.Likes - 1 :  state.postDetails?.PostUser?.Interactions.Likes + 1
          }
        }
      };
    });
  
    builder.addCase(postLike.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(postShare.fulfilled, (state, action) => {
      // state.tags = action.payload;
    });
  
    builder.addCase(postShare.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
    
    builder.addCase(postReply.fulfilled, (state, action) => {
      state.postDetails = {
        ...state.postDetails,
        Replies: [...(state.postDetails.Replies || []), ...action.payload]
      };
    });
  
    builder.addCase(postReply.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(postBookmark.fulfilled, (state, action) => {
      state.postDetails = {
        ...state.postDetails,
        PostUser: {
          ...(state.postDetails?.PostUser || {}),
          Interactions: {
            ...(state.postDetails?.PostUser?.Interactions || {}),
            Bookmark: !action.payload[0]?.IsDelete
          }
        }
      };
    });
  
    builder.addCase(postBookmark.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
  }
});

export default Discussion.reducer;